
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.364 9.636a.9.9 0 001.272-1.272L7.273 6l2.363-2.364a.9.9 0 00-1.272-1.272L6 4.727 3.636 2.364a.9.9 0 00-1.272 1.272L4.727 6 2.364 8.364a.9.9 0 001.272 1.272L6 7.273l2.364 2.363z","fill":"#999"}})])
          )
        }
      }
    